import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { CreatePrivilegeComponent } from '../../role-management/create-privilege/create-privilege.component';
import { Router } from '@angular/router';
import { SuperAgentDetailsModalComponent } from '../super-agent-details-modal/super-agent-details-modal.component';
import { ModalService } from 'src/app/services/modal-service/modal.service';

@Component({
  selector: 'app-super-agent-management-landing',
  templateUrl: './super-agent-management-landing.component.html',
  styleUrl: './super-agent-management-landing.component.scss',
  standalone: false,
})
export class SuperAgentManagementLandingComponent implements OnInit {
  action_idx: any = null;

  superAgents: any[] = [];
  form: FormGroup;

  isSearching: boolean = false;
  showSearchForm: boolean = false;

  searchedSuperAgentNotFound = false;
  isEmpty!: boolean;
  searched = false;
  isLoading: boolean = false;

  selectedStatus!: boolean;

  isDarkMode!: boolean;

  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  count: number = 0;
  pageSize: number = 10;
  selectedLimit: number = 10;

  @Output() onConfirmClicked = new EventEmitter();

  toggleShowSearch() {
    this.showSearchForm = !this.showSearchForm;
  }

  constructor(
    public fb: FormBuilder,
    private apiService: ApiService,
    public dialog: MatDialog,
    private router: Router,
    private modalService: ModalService
  ) { }

  ngOnInit(): void {

    this.form = this.fb.group({
      name: [''],
      status: [''],
      createdBy: [''],
      email: [''],
      phoneNumber: [''],
      from: [''],
      to: [''],
      offset: [''],
    });
    this.search();
  }

  clearSearchFilters() {
    this.form.reset()
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload();
    });
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  openDeactivateConfirmModal(id: number, name: string) {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Deactivate super agent: ' + name + '?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.deactivateSuperAgent(id);
        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  openActivateConfirmModal(id: number, name: string) {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Activate Super Agent: ' + name + '?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.activateSuperAgent(id);
        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }


  isUnlockingAccount: boolean;
  unlockUserAccount(userId: number) {
    this.isUnlockingAccount = true;
    return this.apiService.get(`/auth/user/unlock-account/${userId}`).subscribe((res: any) => {
      if (res.success) {
        res.message && this.modalService.openSuccessModal(res.message).afterClosed().subscribe((data: any) => {
          this.search()
        })
      }

      else {
        this.modalService.openErrorModal(res.message)
      }

      this.isUnlockingAccount = false;

    },
      (error) => {
        this.modalService.openErrorModal(error.message);
        this.isUnlockingAccount = false;
      })
  }

  openDeleteConfirmModal(id: number, name: string) {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Delete super agent: ' + name + '?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.deleteSuperAgent(id);
        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  deleteSuperAgent(id: number): void {
    this.isLoading = true;
    this.apiService
      .get(`/auth/user/delete/${id}`)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (response: any) => {
          this.openSuccessModal('Super agent deleted successfuly');
        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );
  }

  deactivateSuperAgent(id: number): void {
    this.isLoading = true;
    this.apiService
      .get(`/auth/user/deactivate/${id}`)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (response: any) => {
          this.openSuccessModal('Super agent deactivated successfuly');
        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );
  }

  activateSuperAgent(id: number): void {
    this.isLoading = true;
    this.apiService
      .get(`/auth/user/activate/${id}`)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (response: any) => {
          this.openSuccessModal('Super agent activated successfuly');
        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );
  }

  callDb(event: any) {
    this.currentPage = event;

    this.page = event - 1;

    this.search();
  }

  updateLimit() {
    this.currentPage = 1;

    this.page = 0;

    this.search();
  }

  errorFetchingData: boolean = false;


  search() {
    this.superAgents = [];
    this.searchedSuperAgentNotFound = false;
    this.isSearching = true;
    this.errorFetchingData = false;

    this.pageSize = this.selectedLimit;

    this.num = this.page * this.selectedLimit;

    var formData: any = new FormData();

    formData.append('offset', this.num);
    formData.append('limit', this.selectedLimit);
    formData.append('name', this.form.get('name')?.value || '');
    formData.append('email', this.form.get('email')?.value || '');
    formData.append('phoneNumber', this.form.get('phoneNumber')?.value || '');
    formData.append("createdBy", this.form.get('createdBy')?.value || '');
    formData.append("status", this.form.get('status')?.value || '');
    formData.append("from", this.form.get('from')?.value || '');
    formData.append("to", this.form.get('to')?.value || '');

    this.apiService
      .post('/auth/user/super-agents', formData)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          this.superAgents = response.data;

          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedSuperAgentNotFound = true;
          }
        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true;
        }
      );
  }

  splitPriviledges(privileges: String): string[] {
    return privileges?.split(',').map((item) => item.trim());
  }

  openDialogRef(data?: any) {
    let dialogRef = this.dialog.open(CreatePrivilegeComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form'],
      disableClose: true,

      data,
    });

    return dialogRef;
  }

  createSuperAgent() {
    this.router.navigate(['admin/super-agent/create']);
  }

  viewSuperAgent(data: any) {
    let dialog = this.dialog.open(SuperAgentDetailsModalComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'custom-dialog-lg'],
      disableClose: true,

      data,
    })
  }

  updateSuperAgent(data: any) {
    let dialog = this.dialog.open(SuperAgentDetailsModalComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'custom-dialog-lg'],
      disableClose: true,

      data: {...data, isInEditingMode: true },
    })
  }

  editSuperAgent(superAgent: any) {
    // let dialogRef = this.openDialogRef({
    //   ...privilege,
    // });

    // dialogRef.afterClosed().subscribe(() => {
    //   this.search()
    // });
    console.warn('in progress');
  }
}
